import DataGrid from '../../../../../../table/DataGrid'
import IconTooltipButton from '../../../../../../button/IconTooltipButton'
import ChipStatus from '../../Current/Elements/ChipStatus'
import ChipResult from '../../Current/Elements/ChipResult'
import { useSelector } from 'react-redux'
import ItemRule from './ItemRule'

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 20,
      label: 'Name'
    },
    {
      show: true,
      key: 'description',
      align: 'left',
      hide: false,
      width: 50,
      label: 'Description'
    },
    {
      show: true,
      key: 'rulesResults',
      align: 'left',
      hide: false,
      width: 100,
      label: 'Rules'
    },
    {
      show: permissions['preview'] || permissions['update'] || permissions['delete'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 5,
      label: 'actions'
    }
  ]

  return (
    <DataGrid
      id='special-circumstances-statusical-report'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      orderByField='position'
      rows={list.map((row) => {
        return {
          ...row,
          primary: (
            <div className='flex gap-2 items-center justify-start py-2'>
              <ChipResult result={row.name} color={row.color} bgColor={row.bgColor} border={row.border} />
            </div>
          ),
          rulesResults: (
            <div className='flex flex-col gap-2 items-start justify-start py-2'>
              {row.rules.map((rule, index) => (
                <ItemRule key={rule._id || index} index={index} rule={rule} />
              ))}
            </div>
          ),
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onAction('preview', row)}
                />
              )}
              {permissions['update'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['delete'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )
        }
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any result yet"
    />
  )
}

export default List
